module.exports = __webpack_public_path__ + "static/transportation-2.224eca75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/transportation-2.jpg
// module id = 1158
// module chunks = 51824475451446